export default {"src":"/_next/static/media/websitex5.862a990f.svg","height":147,"width":147,"blurWidth":0,"blurHeight":0};